import { Primitive } from "../Primitive/Primitive.js";
import { createBlock, defineComponent, mergeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/Calendar/CalendarGridHead.vue?vue&type=script&setup=true&lang.ts
var CalendarGridHead_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "CalendarGridHead",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false,
			default: "thead"
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Primitive), mergeProps(props, { "aria-hidden": "true" }), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/Calendar/CalendarGridHead.vue
var CalendarGridHead_default = CalendarGridHead_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { CalendarGridHead_default };
//# sourceMappingURL=CalendarGridHead.js.map